var render, staticRenderFns
import script from "./config-calling-row.vue?vue&type=script&lang=js"
export * from "./config-calling-row.vue?vue&type=script&lang=js"
import style0 from "./config-calling-row.vue?vue&type=style&index=0&id=5a9b8d81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports